import * as moment from "moment";

export class DateLocaleService {
    static $inject = ["$window"];

    private defaultLanguage: string = "en";
    public storageLanguage: string = "en";

    constructor(private $window: ng.IWindowService) {
    }

    getLanguage() {
        return this.$window.navigator.language;
    }

    getDateFormat(language: string = null) {
        language = language || this.getLanguage();
        var localeData = moment.localeData(language) || moment.localeData(this.defaultLanguage) || moment.localeData();
        return (<any>localeData).longDateFormat("L");
    }

    parseMoment(dateString: string, language: string = null) {
        var dateFormat = this.getDateFormat(language);
        var dateMoment = moment(dateString, dateFormat);
        dateMoment.locale(this.getLanguage());
        return dateMoment;
        //if (dateMoment.isValid()) {
        //    return dateMoment;
        //} else {
        //    return null;
        //}
    }

	parseDateMoment(date: Date, language: string = null) {
		var dateFormat = this.getDateFormat(language);
		var dateMoment = moment(date, dateFormat);
		dateMoment.locale(this.getLanguage());
		return dateMoment;
	}

    parseStorageMoment(dateString: string) {
        return this.parseMoment(dateString, this.storageLanguage);
    }

    localizeMoment(dateMoment: moment.Moment, language: string = null) {
        dateMoment.locale(language || this.getLanguage());
        return dateMoment;
    }

    delocalizeMoment(dateMoment: moment.Moment) {
        dateMoment.locale(this.storageLanguage);
        return dateMoment;
    }
}